import type { SVGProps } from 'react';
import { clsx } from 'clsx';
import styles from './sort.module.scss';

type SortIconSortValue = 'asc' | 'desc' | undefined;

interface SortIconProps extends SVGProps<SVGSVGElement> {
  sort: SortIconSortValue;
}

export function SortIcon({ className, sort, height = 16, width = 16, ...props }: SortIconProps) {
  return (
    <svg
      aria-label={`Sort direction: ${sort === 'asc' ? 'Ascending' : sort === 'desc' ? 'Descending' : 'Unsorted'}`}
      className={clsx(styles.sort, className)}
      fill="none"
      height={height}
      role="img"
      viewBox="0 0 16 16"
      width={width}
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        className={clsx(sort === 'desc' && styles.active, sort === 'asc' && styles.inactive)}
        clipRule="evenodd"
        d="M11.7123 9.71967C11.4195 9.42678 10.9446 9.42678 10.6517 9.71967L8.00004 12.3713L5.34838 9.71967C5.05549 9.42678 4.58062 9.42678 4.28772 9.71967C3.99483 10.0126 3.99483 10.4874 4.28772 10.7803L7.11615 13.6088C7.60431 14.0969 8.39576 14.0969 8.88392 13.6088L11.7123 10.7803C12.0052 10.4874 12.0052 10.0126 11.7123 9.71967Z"
        fillRule="evenodd"
      />
      <path
        className={clsx(sort === 'asc' && styles.active, sort === 'desc' && styles.inactive)}
        clipRule="evenodd"
        d="M11.7123 6.28033C11.4195 6.57322 10.9446 6.57322 10.6517 6.28033L8.00004 3.62868L5.34838 6.28033C5.05549 6.57322 4.58062 6.57322 4.28772 6.28033C3.99483 5.98744 3.99483 5.51256 4.28772 5.21967L7.11615 2.39124C7.60431 1.90309 8.39576 1.90309 8.88392 2.39124L11.7123 5.21967C12.0052 5.51256 12.0052 5.98744 11.7123 6.28033Z"
        fillRule="evenodd"
      />
    </svg>
  );
}
